import type {
  SchemaFocusDomain,
  SchemaQuestionTemplate,
  SchemaSessionStartBody,
} from '@/services/api/schemaSessions'

export const MAX_REFERENCE_FILES = 10
/** Focus areas a session without files may pick on top of pole-basic (backend: MAX_FOCUS_DOMAINS). */
export const MAX_FOCUS_DOMAINS = 3
/** The catalogue domains offered as focus areas, in catalogue order; core is pole-basic itself. */
export const FOCUS_DOMAINS: readonly SchemaFocusDomain[] = [
  'financial',
  'crypto',
  'comms',
  'geo',
  'corporate',
  'military',
]

/** The fixed question templates, in form order (backend: ``catalogue/intake.py``). */
export const QUESTION_TEMPLATES: readonly SchemaQuestionTemplate[] = [
  'contact_network',
  'location_on_date',
  'money_between_accounts',
  'units_and_personnel',
]

export const emptyIntake = (): SchemaSessionStartBody => ({
  documentIds: [],
  caseType: 'other',
  investigationGoal: '',
  primaryQuestions: [],
  focusDomains: [],
  customQuestions: [],
  subjects: [],
  evidenceTypes: [],
  timeWindow: null,
  geographicScope: null,
  notes: '',
})

export function intakeErrors(intake: SchemaSessionStartBody): string[] {
  const errors: string[] = []
  if (intake.documentIds.length > MAX_REFERENCE_FILES) errors.push('documents')
  // Without files the objective is the agent's only brief (PRD-0073).
  if (intake.documentIds.length === 0 && !intake.investigationGoal.trim())
    errors.push('goalRequired')
  if (intake.focusDomains.length > MAX_FOCUS_DOMAINS) errors.push('focusCount')
  if (intake.investigationGoal.length > 4000) errors.push('goalLength')
  if (intake.customQuestions.length > 10) errors.push('questionCount')
  if (intake.customQuestions.some(question => question.length > 2000)) errors.push('questionLength')
  if (
    intake.subjects.some(
      subject => !Number.isInteger(subject.count) || subject.count < 1 || subject.count > 999
    )
  )
    errors.push('subjects')
  const { start, end } = intake.timeWindow ?? {}
  if (start && end && start > end) errors.push('dates')
  return errors
}

export const SUBJECT_ROLES = ['suspect', 'victim', 'witness', 'org'] as const
